import { useTranslation } from 'react-i18next'
import { useDeleteIntegrator } from '@dhl/mdp-api'
import { ConfirmationDialog } from '@dhl/confirmation-dialog'
import { Body1 } from '@dhl-ui/components'
import { useNotificationMessage } from '~/common'

type Props = {
  open: boolean
  id: string
  onClose: () => void
  onDeleteComplete: () => void
}

export const IntegratorDangerZoneDialog = ({ open, id, onClose, onDeleteComplete }: Props) => {
  const { showError, showSuccess } = useNotificationMessage()
  const { t } = useTranslation()
  const { mutate: deleteIntegrator } = useDeleteIntegrator()

  const handleDelete = () => {
    deleteIntegrator(
      {
        id,
      },
      {
        onSuccess: () => {
          showSuccess(t('admin.integratorsPage.deleteIntegrator'))
          onDeleteComplete()
        },
        onError: (response) => {
          showError(response?.message ?? t('admin.integratorsPage.errorMessage'))
        },
      }
    )
  }

  return (
    <ConfirmationDialog
      open={open}
      titleText={t(`admin.integratorsPage.dangerZoneTitle`)}
      acceptText={t(`admin.integratorsPage.dangerZoneHeader`)}
      rejectText={t(`admin.integratorsPage.cancelButton`)}
      onAccept={handleDelete}
      onReject={() => id && onClose()}
    >
      <Body1>{t(`admin.integratorsPage.dangerZoneMessage`)}</Body1>
    </ConfirmationDialog>
  )
}
